<template>
  <div
    class="modal fade"
    id="thankYouSuggestions"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-575 modal-top-spacing">
      <div class="modal-content">
        <div class="gt-md-modal-header">
          <h2>Message Suggestions</h2>
          <div class="gt-modal-close" data-dismiss="modal">
            <a href="#">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.2543 1.7168L9.07513 8.89599L16.2543 16.0752"
                  stroke="#1E2437"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.89594 16.0752L9.07513 8.896L1.89594 1.71681"
                  stroke="#1E2437"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>
        <!-- gt-md-modal-header -->
        <div class="modal-body text-center theme-tabs">
          <div class="suggestion-text-inner">
            <p>
              Here's some suggestions you can use. Choose one and edit it to
              suit.
            </p>
            <div class="suggestion-block">
              <p id="Suggestiontext1">
                I was so touched to receive the gift from you all. It means so
                much to me that you thought of me and took the time to choose a
                gift and leave such thoughtful messages on the card. I will
                cherish them both. <br />
                Thank you again for your generosity and kindness.
              </p>
              <button
                class="theme-btn-lite"
                type="button"
                @click="HandleSuggestionSelect(1)"
              >
                Insert
              </button>
            </div>
            <!-- suggestion-block -->
            <div class="suggestion-block">
              <p id="Suggestiontext2">
                Dear colleagues, <br />
                I was so grateful to receive the gift from you all. It's exactly
                what I've been wanting, and I can't wait to use it. I know you
                all put a lot of thought into the messages that you left me, and
                I really appreciate it. <br />
                It means so much to me that you thought of me and wanted to do
                something nice.
              </p>
              <button
                class="theme-btn-lite"
                type="button"
                @click="HandleSuggestionSelect(2)"
              >
                Insert
              </button>
            </div>
            <!-- suggestion-block -->
            <div class="suggestion-block">
              <p id="Suggestiontext3">
                Dear parents, <br />
                I was so surprised to receive the gift from you all. I'm so
                proud of all of your children and for the hard work they put in
                this year. They've all grown so much, and I'm so excited to see
                what they accomplish in the future. <br />
                Thank you again for your generosity and kindness.
              </p>
              <button
                class="theme-btn-lite"
                type="button"
                @click="HandleSuggestionSelect(3)"
              >
                Insert
              </button>
            </div>
            <!-- suggestion-block -->
            <div class="suggestion-block">
              <p id="Suggestiontext4">
                I am so happy for the thoughtful gift you all chipped in to get
                me. I was so touched when I read the messages on the card, it's
                so lovely and I know I will treasure it always.
              </p>
              <button
                class="theme-btn-lite"
                type="button"
                @click="HandleSuggestionSelect(4)"
              >
                Insert
              </button>
            </div>
            <!-- suggestion-block -->
            <div class="suggestion-block">
              <p id="Suggestiontext5">
                I am writing to thank you for the thoughtful gift and wonderful
                card you all got me. My partner and I are so excited to welcome
                the baby into the world, and this gift will help us to make sure
                that they are comfortable and well-cared for.
              </p>
              <button
                class="theme-btn-lite"
                type="button"
                @click="HandleSuggestionSelect(5)"
              >
                Insert
              </button>
            </div>
            <!-- suggestion-block -->
            <div class="suggestion-block">
              <p id="Suggestiontext6">
                Oh my goodness, <br />
                you guys really know how to make a person feel special! I was
                seriously touched, it's like you have a PhD in "awesome present
                selection"! And don't even get me started on the card - I
                laughed, I cried, I did a little happy dance. Those messages
                were pure gold! I'm seriously considering framing them and
                turning them into a best-selling novel.
              </p>
              <button
                class="theme-btn-lite"
                type="button"
                @click="HandleSuggestionSelect(2)"
              >
                Insert
              </button>
            </div>
            <!-- suggestion-block -->
            <div class="suggestion-block">
              <p id="Suggestiontext7">
                Thank you from the bottom of my heart for thinking of me and
                making my day brighter. I'm truly lucky to be surrounded by such
                amazing individuals like yourselves. You've raised the bar for
                office gift-giving to new heights. <br />
                Cheers to the best colleagues ever!
              </p>
              <button
                class="theme-btn-lite"
                type="button"
                @click="HandleSuggestionSelect(7)"
              >
                Insert
              </button>
            </div>
            <!-- suggestion-block -->
            <div class="suggestion-block">
              <p id="Suggestiontext8">
                My dear friends, <br />
                I wanted to express my heartfelt gratitude for your unwavering
                support during this difficult time. Your thoughtful gift and
                comforting messages have been a ray of light amidst the
                darkness, reminding me that I am not alone. Your presence and
                acts of kindness have made a profound impact on my healing
                journey, and I am forever grateful. <br />
                With sincere appreciation.
              </p>
              <button
                class="theme-btn-lite"
                type="button"
                @click="HandleSuggestionSelect(8)"
              >
                Insert
              </button>
            </div>
            <!-- suggestion-block -->
            <div class="suggestion-block">
              <p id="Suggestiontext9">
                Dear friends, <br />
                I wanted to take a moment to express my sincere gratitude for
                the lovely flowers you gave me. They brought such warmth and
                beauty to my surroundings, and I couldn't help but feel a sense
                of appreciation and joy. Thank you for thinking of me and
                brightening my day. <br />
                With heartfelt thanks.
              </p>
              <button
                class="theme-btn-lite"
                type="button"
                @click="HandleSuggestionSelect(9)"
              >
                Insert
              </button>
            </div>
            <!-- suggestion-block -->
            <div class="suggestion-block">
              <p id="Suggestiontext10">
                Dearest friends, <br />
                You must be a wizard of laughter and happiness because those
                flowers you gave me had me grinning like a Cheshire cat on a
                caffeine rush! I mean, seriously, they were so vibrant and
                dazzling that I'm convinced they must have attended flower
                beauty school. Thank you for adding a touch of whimsy to my
                days! With a bouquet of laughter.
              </p>
              <button
                class="theme-btn-lite"
                type="button"
                @click="HandleSuggestionSelect(10)"
              >
                Insert
              </button>
            </div>
            <!-- suggestion-block -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SuggestionsModal",
  components: {},
  props: {},
  data: function () {},
  mounted: function () {},
  methods: {
    HandleSuggestionSelect(Id) {
      var suggestion = $("#Suggestiontext" + Id).html();
      this.$emit("select-suggestion", suggestion);
    },
  },
};
</script>
